export const DEFAULT_SCRIM_OPACITY = 0.3;

export const DEFAULT_SPINNER_SIZE = 50;
